import {request} from '..';

export const getTranslations = (translationKeys?: string[]) => {
  return request<ToolboxObject.Translation[]>({
    url: '/translations/fetch',
    method: 'POST',
    data: {
      translationKeys,
    },
  });
};

export const getAITranslation = (data: {message: string; lang: string}) => {
  return request<string[]>({
    url: '/translations/help',
    method: 'POST',
    data,
  });
};

export const updateTranslation = (id: number, data: Omit<ToolboxObject.Translation, 'id'>) => {
  return request<ToolboxObject.Translation>({
    url: `/translations/${id}`,
    method: 'PUT',
    data,
  });
};

export const createTranslation = (data: Omit<ToolboxObject.Translation, 'id'>) => {
  return request<ToolboxObject.Translation>({
    url: `/translations`,
    method: 'POST',
    data,
  });
};

export const deleteTranslation = (id: number) => {
  return request<number>({
    url: `/translations/${id}`,
    method: 'DELETE',
  });
};

export type UpsertEntityTranslationFn = (entityId: number, data: ToolboxObject.UpsertTranslationDto) => Promise<ToolboxObject.EntityTranslation>;

export const upsertMethodTranslation: UpsertEntityTranslationFn = (methodId, data) => {
  return request<ToolboxObject.EntityTranslation>({
    url: `/translations/methods/${methodId}`,
    method: 'POST',
    data,
  });
};

export const upsertMethodInfoTranslation: UpsertEntityTranslationFn = (methodId, data) => {
  return request<ToolboxObject.EntityTranslation>({
    url: `/translations/methods/${methodId}/infos`,
    method: 'POST',
    data,
  });
};

export const upsertMethodMaterialTranslation: UpsertEntityTranslationFn = (methodId, data) => {
  return request<ToolboxObject.EntityTranslation>({
    url: `/translations/methods/${methodId}/materials`,
    method: 'POST',
    data,
  });
};

export const upsertMethodStepTranslation: UpsertEntityTranslationFn = (methodId, data) => {
  return request<ToolboxObject.EntityTranslation>({
    url: `/translations/methods/${methodId}/steps`,
    method: 'POST',
    data,
  });
};

export const upsertWorkshopTranslation: UpsertEntityTranslationFn = (workshopId, data) => {
  return request<ToolboxObject.EntityTranslation>({
    url: `/translations/workshops/${workshopId}`,
    method: 'POST',
    data,
  });
};

export const upsertWorkshopInfoTranslation: UpsertEntityTranslationFn = (workshopId, data) => {
  return request<ToolboxObject.EntityTranslation>({
    url: `/translations/workshops/${workshopId}/infos`,
    method: 'POST',
    data,
  });
};
